webpackJsonp([3],{

/***/ "+3pp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom__ = __webpack_require__("Gxuq");
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'mt-swipe',
    created: function created() {
        this.dragState = {};
    },
    data: function data() {
        return {
            ready: false,
            dragging: false,
            userScrolling: false,
            animating: false,
            index: 0,
            pages: [],
            timer: null,
            reInitTimer: null,
            noDrag: false,
            isDone: false,
            disableChange: false //阻止 touchend 时的切换
        };
    },

    props: {
        speed: {
            type: Number,
            default: 300
        },
        defaultIndex: {
            type: Number,
            default: 0
        },
        auto: {
            type: Number,
            default: 3000
        },
        continuous: {
            type: Boolean,
            default: true
        },
        showIndicators: {
            type: Boolean,
            default: true
        },
        noDragWhenSingle: {
            type: Boolean,
            default: true
        },
        prevent: {
            type: Boolean,
            default: false
        },
        stopPropagation: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        index: function index(newIndex) {
            this.$emit('change', newIndex);
        }
    },
    methods: {
        swipeItemCreated: function swipeItemCreated() {
            var _this = this;

            if (!this.ready) return;
            clearTimeout(this.reInitTimer);
            this.reInitTimer = setTimeout(function () {
                _this.reInitPages();
            }, 100);
        },
        swipeItemDestroyed: function swipeItemDestroyed() {
            var _this2 = this;

            if (!this.ready) return;
            clearTimeout(this.reInitTimer);
            this.reInitTimer = setTimeout(function () {
                _this2.reInitPages();
            }, 100);
        },
        rafTranslate: function rafTranslate(element, initOffset, offset, callback, nextElement) {
            var ALPHA = 0.88;
            this.animating = true;
            var _offset = initOffset;
            var raf = 0;

            function animationLoop() {
                if (Math.abs(_offset - offset) < 0.5) {
                    this.animating = false;
                    _offset = offset;
                    element.style.webkitTransform = '';
                    if (nextElement) {
                        nextElement.style.webkitTransform = '';
                    }
                    cancelAnimationFrame(raf);
                    if (callback) {
                        callback();
                    }
                    return;
                }
                _offset = ALPHA * _offset + (1.0 - ALPHA) * offset;
                element.style.webkitTransform = 'translate3d(' + _offset + 'px, 0, 0)';
                if (nextElement) {
                    nextElement.style.webkitTransform = 'translate3d(' + (_offset - offset) + 'px, 0, 0)';
                }
                raf = requestAnimationFrame(animationLoop.bind(this));
            }

            animationLoop.call(this);
        },
        translate: function translate(element, offset, speed, callback) {
            var _this3 = this,
                _arguments = arguments;

            if (speed) {
                this.animating = true;
                element.style.webkitTransition = '-webkit-transform ' + speed + 'ms ease-in-out';
                setTimeout(function () {
                    element.style.webkitTransitionDuration = '300ms';
                    element.style.webkitTransform = 'translate3d(' + offset + 'px, 0, 0)';
                }, 50);
                var called = false;
                var transitionEndCallback = function transitionEndCallback() {
                    if (called) return;
                    called = true;
                    _this3.animating = false;
                    element.style.webkitTransition = '';
                    element.style.webkitTransform = '';
                    if (callback) {
                        callback.apply(_this3, _arguments);
                    }
                };
                Object(__WEBPACK_IMPORTED_MODULE_0__dom__["b" /* once */])(element, 'webkitTransitionEnd', transitionEndCallback);
                setTimeout(transitionEndCallback, speed + 100); // webkitTransitionEnd maybe not fire on lower version android.
            } else {
                element.style.webkitTransition = '';
                element.style.webkitTransitionDuration = '0ms';
                element.style.webkitTransform = 'translate3d(' + offset + 'px, 0, 0)';
            }
        },
        reInitPages: function reInitPages() {
            var children = this.$children;
            this.noDrag = children.length === 1 && this.noDragWhenSingle;
            var pages = [];
            var intDefaultIndex = Math.floor(this.defaultIndex);
            var defaultIndex = intDefaultIndex >= 0 && intDefaultIndex < children.length ? intDefaultIndex : 0;
            this.index = defaultIndex;
            children.forEach(function (child, index) {
                pages.push(child.$el);
                Object(__WEBPACK_IMPORTED_MODULE_0__dom__["c" /* removeClass */])(child.$el, 'is-active');
                if (index === defaultIndex) {
                    Object(__WEBPACK_IMPORTED_MODULE_0__dom__["a" /* addClass */])(child.$el, 'is-active');
                }
            });
            this.pages = pages;
        },
        doAnimate: function doAnimate(towards, options) {
            var _this4 = this;

            if (this.$children.length === 0) return;
            if (!options && this.$children.length < 2) return;
            var prevPage, nextPage, currentPage, pageWidth, offsetLeft, speedX;
            var speed = this.speed || 300;
            var index = this.index;
            var pages = this.pages;
            var pageCount = pages.length;
            if (!options) {
                pageWidth = this.$el.clientWidth;
                currentPage = pages[index];
                prevPage = pages[index - 1];
                nextPage = pages[index + 1];
                if (this.continuous && pages.length > 1) {
                    if (!prevPage) {
                        prevPage = pages[pages.length - 1];
                    }
                    if (!nextPage) {
                        nextPage = pages[0];
                    }
                }
                if (prevPage) {
                    prevPage.style.display = 'block';
                    this.translate(prevPage, -pageWidth);
                }
                if (nextPage) {
                    nextPage.style.display = 'block';
                    this.translate(nextPage, pageWidth);
                }
            } else {
                prevPage = options.prevPage;
                currentPage = options.currentPage;
                nextPage = options.nextPage;
                pageWidth = options.pageWidth;
                offsetLeft = options.offsetLeft;
                speedX = options.speedX;
            }
            var newIndex;
            var oldPage = this.$children[index].$el;
            if (towards === 'prev') {
                if (index > 0) {
                    newIndex = index - 1;
                }
                if (this.continuous && index === 0) {
                    newIndex = pageCount - 1;
                }
            } else if (towards === 'next') {
                if (index < pageCount - 1) {
                    newIndex = index + 1;
                }
                if (this.continuous && index === pageCount - 1) {
                    newIndex = 0;
                }
            }
            var callback = function callback() {
                if (newIndex !== undefined) {
                    var newPage = _this4.$children[newIndex].$el;
                    Object(__WEBPACK_IMPORTED_MODULE_0__dom__["c" /* removeClass */])(oldPage, 'is-active');
                    Object(__WEBPACK_IMPORTED_MODULE_0__dom__["a" /* addClass */])(newPage, 'is-active');
                    _this4.index = newIndex;
                }
                if (_this4.isDone) {
                    _this4.end();
                }
                if (prevPage) {
                    prevPage.style.display = '';
                }
                if (nextPage) {
                    nextPage.style.display = '';
                }
            };
            setTimeout(function () {
                if (towards === 'next') {
                    _this4.isDone = true;
                    _this4.before(currentPage);
                    if (speedX) {
                        _this4.rafTranslate(currentPage, offsetLeft, -pageWidth, callback, nextPage);
                    } else {
                        _this4.translate(currentPage, -pageWidth, speed, callback);
                        if (nextPage) {
                            _this4.translate(nextPage, 0, speed);
                        }
                    }
                } else if (towards === 'prev') {
                    _this4.isDone = true;
                    _this4.before(currentPage);
                    if (speedX) {
                        _this4.rafTranslate(currentPage, offsetLeft, pageWidth, callback, prevPage);
                    } else {
                        _this4.translate(currentPage, pageWidth, speed, callback);
                        if (prevPage) {
                            _this4.translate(prevPage, 0, speed);
                        }
                    }
                } else {
                    _this4.isDone = false;
                    _this4.translate(currentPage, 0, speed, callback);
                    if (typeof offsetLeft !== 'undefined') {
                        if (prevPage && offsetLeft > 0) {
                            _this4.translate(prevPage, pageWidth * -1, speed);
                        }
                        if (nextPage && offsetLeft < 0) {
                            _this4.translate(nextPage, pageWidth, speed);
                        }
                    } else {
                        if (prevPage) {
                            _this4.translate(prevPage, pageWidth * -1, speed);
                        }
                        if (nextPage) {
                            _this4.translate(nextPage, pageWidth, speed);
                        }
                    }
                }
            }, 10);
        },
        next: function next() {
            this.doAnimate('next');
        },
        prev: function prev() {
            this.doAnimate('prev');
        },
        before: function before() {
            this.$emit('before', this.index);
        },
        end: function end() {
            this.$emit('end', this.index);
        },
        doOnTouchStart: function doOnTouchStart(event) {
            if (this.noDrag) return;
            var element = this.$el;
            var dragState = this.dragState;
            var touch = event.touches[0];
            dragState.startTime = new Date();
            dragState.startLeft = touch.pageX;
            dragState.startTop = touch.pageY;
            dragState.startTopAbsolute = touch.clientY;
            dragState.pageWidth = element.offsetWidth;
            dragState.pageHeight = element.offsetHeight;
            var prevPage = this.$children[this.index - 1];
            var dragPage = this.$children[this.index];
            var nextPage = this.$children[this.index + 1];
            if (this.continuous && this.pages.length > 1) {
                if (!prevPage) {
                    prevPage = this.$children[this.$children.length - 1];
                }
                if (!nextPage) {
                    nextPage = this.$children[0];
                }
            }
            dragState.prevPage = prevPage ? prevPage.$el : null;
            dragState.dragPage = dragPage ? dragPage.$el : null;
            dragState.nextPage = nextPage ? nextPage.$el : null;
            if (dragState.prevPage) {
                dragState.prevPage.style.display = 'block';
            }
            if (dragState.nextPage) {
                dragState.nextPage.style.display = 'block';
            }
        },
        doOnTouchMove: function doOnTouchMove(event) {
            if (this.noDrag) return;
            var dragState = this.dragState;
            var touch = event.touches[0];
            dragState.speedX = touch.pageX - dragState.currentLeft;
            dragState.currentLeft = touch.pageX;
            dragState.currentTop = touch.pageY;
            dragState.currentTopAbsolute = touch.clientY;
            var offsetLeft = dragState.currentLeft - dragState.startLeft;
            var offsetTop = dragState.currentTopAbsolute - dragState.startTopAbsolute;
            var distanceX = Math.abs(offsetLeft);
            var distanceY = Math.abs(offsetTop);
            if (distanceX < 5 || distanceX >= 5 && distanceY >= 1.73 * distanceX) {
                //                    console.log("X方向位移太小或者Y方向的偏移比例明显更大");
                this.userScrolling = true;
                return;
            } else {
                this.userScrolling = false;
                event.preventDefault();
                event.stopPropagation();
            }
            offsetLeft = Math.min(Math.max(-dragState.pageWidth + 1, offsetLeft), dragState.pageWidth - 1);
            var towards = offsetLeft < 0 ? 'next' : 'prev';
            if (dragState.prevPage && towards === 'prev') {
                this.translate(dragState.prevPage, offsetLeft - dragState.pageWidth);
            }
            this.translate(dragState.dragPage, offsetLeft);
            if (dragState.nextPage && towards === 'next') {
                this.translate(dragState.nextPage, offsetLeft + dragState.pageWidth);
            }
        },
        doOnTouchEnd: function doOnTouchEnd() {
            if (this.noDrag) return;
            var dragState = this.dragState;
            var dragDuration = new Date() - dragState.startTime;
            var towards = null;
            var offsetLeft = dragState.currentLeft - dragState.startLeft;
            var offsetTop = dragState.currentTop - dragState.startTop;
            var pageWidth = dragState.pageWidth;
            var index = this.index;
            var pageCount = this.pages.length;
            if (dragDuration < 300) {
                var fireTap = Math.abs(offsetLeft) < 5 && Math.abs(offsetTop) < 5;
                if (isNaN(offsetLeft) || isNaN(offsetTop)) {
                    fireTap = true;
                }
                if (fireTap) {
                    this.$children[this.index].$emit('tap');
                }
            }
            if (dragDuration < 300 && dragState.currentLeft === undefined) return;
            if (dragDuration < 300 || Math.abs(offsetLeft) > pageWidth / 2) {
                towards = offsetLeft < 0 ? 'next' : 'prev';
            }
            if (!this.continuous) {
                if (index === 0 && towards === 'prev' || index === pageCount - 1 && towards === 'next') {
                    towards = null;
                }
            }
            if (this.$children.length < 2) {
                towards = null;
            }
            this.doAnimate(towards, {
                offsetLeft: offsetLeft,
                pageWidth: dragState.pageWidth,
                prevPage: dragState.prevPage,
                currentPage: dragState.dragPage,
                nextPage: dragState.nextPage,
                speedX: dragState.speedX
            });
            this.dragState = {};
        },
        initTimer: function initTimer() {
            var _this5 = this;

            if (this.auto > 0 && !this.timer) {
                this.timer = setInterval(function () {
                    if (!_this5.continuous && _this5.index >= _this5.pages.length - 1) {
                        return _this5.clearTimer();
                    }
                    if (!_this5.dragging && !_this5.animating) {
                        _this5.next();
                    }
                }, this.auto);
            }
        },
        clearTimer: function clearTimer() {
            clearInterval(this.timer);
            this.timer = null;
        }
    },
    destroyed: function destroyed() {
        if (this.timer) {
            this.clearTimer();
        }
        if (this.reInitTimer) {
            clearTimeout(this.reInitTimer);
            this.reInitTimer = null;
        }
    },
    mounted: function mounted() {
        var _this6 = this;

        this.ready = true;
        this.initTimer();
        this.reInitPages();
        var element = this.$el;
        element.addEventListener('touchstart', function (event) {
            if (_this6.prevent) event.preventDefault();
            if (_this6.stopPropagation) event.stopPropagation();
            if (_this6.animating) return;
            _this6.dragging = true;
            _this6.userScrolling = false;
            _this6.doOnTouchStart(event);
        });
        element.addEventListener('touchmove', function (event) {
            if (!_this6.dragging) return;
            if (_this6.timer) _this6.clearTimer();
            _this6.doOnTouchMove(event);
        });
        element.addEventListener('touchend', function (event) {
            if (_this6.userScrolling) {
                _this6.dragging = false;
                _this6.dragState = {};
                return;
            }
            if (!_this6.dragging) return;
            _this6.initTimer();
            _this6.doOnTouchEnd(event);
            _this6.dragging = false;
        });
    }
});

/***/ }),

/***/ "0UOm":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.mint-swipe {\n  overflow: hidden;\n  position: relative;\n  height: 100%;\n}\n.mint-swipe .mint-swipe-items-wrap {\n  position: relative;\n  overflow: hidden;\n  height: 100%;\n}\n.mint-swipe .mint-swipe-items-wrap > div {\n  position: absolute;\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n  width: 100%;\n  height: 100%;\n  display: none;\n}\n.mint-swipe .mint-swipe-items-wrap > div.is-active {\n  display: block;\n  -webkit-transform: none;\n          transform: none;\n}\n.mint-swipe .mint-swipe-indicators .mint-swipe-indicator {\n  display: inline-block;\n  width: 0.213333rem;\n  height: 0.213333rem;\n  border-radius: 100%;\n  background: #000;\n  opacity: .2;\n  margin: 0 0.08rem;\n}", ""]);

// exports


/***/ }),

/***/ "0mnj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__swiper_index__ = __webpack_require__("KIWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__swiper_item__ = __webpack_require__("i8KL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__("XQ5N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_native_util_js__ = __webpack_require__("UTZg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        target: {
            default: '',
            type: String
        },
        spm: {
            default: '',
            type: String
        },
        data: {
            type: Array,
            default: []
        },
        findex: {
            default: '',
            type: [String, Number]
        },
        tag: {
            default: '',
            type: String
        }
    },
    methods: {
        focus_img: function focus_img(url) {
            return 'background-image:url(\'' + url + '\')';
        },
        onSlide: function onSlide(index) {
            this.$emit('focus_slide', index);
        },
        clickItemHandler: function clickItemHandler(index) {
            var pics = this.$refs.pics;
            var url = pics[index].getAttribute('href');
            __WEBPACK_IMPORTED_MODULE_3__utils_native_util_js__["a" /* default */].openContent(url, this.focus_list[index]);
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            var focusList = void 0,
                container = document.getElementById(_this.target);
            if (container) {
                focusList = container.querySelectorAll('a[data-log-content-ev]');
                _this.$emit('mounted', focusList);
            }
        });
    },

    computed: {
        focus_list: function focus_list() {
            var subId = window.subData.id;
            var flag_index = this.findex;
            var item = void 0,
                stat_flag = '',
                jump_link = void 0;
            this.data.forEach(function (item, index) {
                stat_flag = 'm-' + subId + '_subfocus_' + flag_index + '_' + (index + 1);
                item.stat_flag = stat_flag;
                jump_link = item.link || '/a/' + item.articleId + '_' + item.authId;
                item.link = item.link ? __WEBPACK_IMPORTED_MODULE_2__utils_util__["a" /* default */].addQueryArgs(jump_link, {
                    _f: stat_flag
                }) : null;
                item.picUrl = item.picUrl || item.imageUrl;
            });
            return this.data;
        },
        has_data: function has_data() {
            return this.data.length > 0;
        }
    },
    components: {
        Swipe: __WEBPACK_IMPORTED_MODULE_0__swiper_index__["a" /* default */],
        SwipeItem: __WEBPACK_IMPORTED_MODULE_1__swiper_item__["a" /* default */]
    }
});

/***/ }),

/***/ "0yPF":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1jxY");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("ebc24e3a", content, true, {});

/***/ }),

/***/ "1jxY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "3lR8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Focus_vue__ = __webpack_require__("0mnj");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4df528_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Focus_vue__ = __webpack_require__("wDh7");
function injectStyle (ssrContext) {
  __webpack_require__("ejkq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Focus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc4df528_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Focus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "62WC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mint-swipe"},[_c('div',{ref:"wrap",staticClass:"mint-swipe-items-wrap"},[_vm._t("default")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIndicators),expression:"showIndicators"}],staticClass:"mint-swipe-indicators"},_vm._l((_vm.pages),function(page,$index){return _c('div',{key:$index,staticClass:"mint-swipe-indicator",class:{ 'is-active': $index === _vm.index }})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Br0I":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "Gxuq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export on */
/* unused harmony export off */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return once; });
/* unused harmony export hasClass */
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeClass;
/* unused harmony export getStyle */
/* unused harmony export setStyle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);



var isServer = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
};

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else {
      if (!hasClass(el, clsName)) {
        curClass += ' ' + clsName;
      }
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
};

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else {
      if (hasClass(el, clsName)) {
        curClass = curClass.replace(' ' + clsName + ' ', ' ');
      }
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
};

/* istanbul ignore next */
var getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
};

/***/ }),

/***/ "Jy6i":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0UOm");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("4693bb22", content, true, {});

/***/ }),

/***/ "KIWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("+3pp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b37cf154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("62WC");
function injectStyle (ssrContext) {
  __webpack_require__("Jy6i")
  __webpack_require__("0yPF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b37cf154_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OAH+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "UTZg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__("XQ5N");


var nativeUtil = {
    openContent: function openContent(url, data) {
        if (!url) {
            return;
        }
        if (/MSOHU/i.test(window.navigator.userAgent) && window.Panther) {
            var urlObj = __WEBPACK_IMPORTED_MODULE_0__utils_util__["a" /* default */].parseURL(url);
            var spmCode = urlObj.spm || '';
            var scmCode = urlObj.scm || '';
            var regMatch = /\/(a|picture)\/(\d+)(_\d+\?|\?)/.test(url);
            var authorId = data.authorId || data.authId;
            if (RegExp.$1 === 'a') {
                // 匹配文章页
                if (typeof Panther.openNewsContent === 'function') {
                    Panther.openNewsContent(RegExp.$2, spmCode, scmCode, authorId);
                } else {
                    window.location.href = url;
                }
            } else if (RegExp.$1 === 'picture') {
                // 匹配图集页
                if (typeof Panther.openImageSet === 'function') {
                    Panther.openImageSet(Number(RegExp.$2), spmCode, scmCode, authorId);
                } else {
                    window.location.href = url;
                }
            } else {
                window.location.href = url;
            }
        } else {
            window.location.href = url;
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (nativeUtil);

/***/ }),

/***/ "ejkq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("zlH2");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5bf250e5", content, true, {});

/***/ }),

/***/ "i8KL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_item_vue__ = __webpack_require__("ywRC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c261d43_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_item_vue__ = __webpack_require__("vV6R");
function injectStyle (ssrContext) {
  __webpack_require__("jadq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c261d43_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jadq":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("OAH+");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("66b8ba01", content, true, {});

/***/ }),

/***/ "kxFB":
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ "vV6R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swipe-item"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wDh7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"focus-total-wrap"},[(_vm.tag)?_c('h1',{staticClass:"focus-pics-title"},[_vm._v(_vm._s(_vm.tag))]):_vm._e(),_vm._v(" "),(_vm.has_data)?_c('section',{staticClass:"focus-wrap module-wrap",attrs:{"id":_vm.target,"data-spm":_vm.spm}},[_c('swipe',{attrs:{"auto":3000},on:{"change":_vm.onSlide}},[_vm._l((_vm.focus_list),function(item,index){return [_c('swipe-item',{key:index},[_c('a',{ref:"pics",refInFor:true,attrs:{"href":item.link ? item.link : 'javascript:;',"data-log-content-ev":item.stat_flag},on:{"click":function($event){$event.preventDefault();_vm.clickItemHandler(index)}}},[_c('div',{staticClass:"focus_item",style:(_vm.focus_img(item.picUrl))},[_c('footer',{staticClass:"info"},[_c('h3',{staticClass:"tt"},[_vm._v(_vm._s(item.title))])])])])])]})],2)],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ywRC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'swipe-item',
  mounted: function mounted() {
    this.$parent && this.$parent.swipeItemCreated(this);
  },
  destroyed: function destroyed() {
    this.$parent && this.$parent.swipeItemDestroyed(this);
  }
});

/***/ }),

/***/ "zlH2":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.focus-total-wrap {\n  padding-top: 0.16rem;\n  margin-bottom: 0.266667rem;\n}\n.focus-total-wrap .focus-pics-title {\n  margin: 0 0 0.266667rem 0.293333rem;\n  font-size: 17px;\n  font-weight: bold;\n  color: #222222;\n}\n.focus-total-wrap .focus-wrap {\n  height: 5.013333rem;\n}\n.focus-total-wrap .focus-wrap .mint-swipe .mint-swipe-indicators {\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  bottom: 0.266667rem;\n}\n.focus-total-wrap .focus-wrap .mint-swipe .mint-swipe-indicators .mint-swipe-indicator {\n  width: 6px;\n  height: 2px;\n  margin: 0 2px;\n  opacity: 0.6;\n  background: #515355;\n  border-radius: 5px;\n}\n.focus-total-wrap .focus-wrap .mint-swipe .mint-swipe-indicators .mint-swipe-indicator.is-active {\n  background-color: #fdd000;\n  opacity: 1;\n}\n.focus-total-wrap .focus_item {\n  position: relative;\n  height: 100%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-image: url(" + escape(__webpack_require__("Br0I")) + ");\n}\n.focus-total-wrap .focus_item .info {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 1.6rem;\n  background-color: red;\n  background: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 0)), to(rgba(57, 57, 57, 0.85)));\n  background: linear-gradient(rgba(0, 0, 0, 0), rgba(57, 57, 57, 0.85));\n}\n.focus-total-wrap .focus_item .info .tt {\n  position: absolute;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  bottom: 0.48rem;\n  font-size: 18px;\n  line-height: 1.2em;\n  font-weight: bold;\n  padding-left: 0.346667rem;\n  padding-right: 0.346667rem;\n  color: #fff;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}", ""]);

// exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/3.1048e4a3377887cc5017.js